// checkout how we use getBoundingClientRect to find the element's position here:
// https://stackoverflow.com/questions/442404/retrieve-the-position-x-y-of-an-html-element-relative-to-the-browser-window#11396681

export const scrollToElementById = (
    id: string,
    device: "mobile" | "desktop",
    behavior: ScrollBehavior = "smooth"
) => {
    // get the element we want to scroll to
    const el = document.getElementById(id);
    // if we cannot find element, return
    if (el === undefined || el === null) return;
    // if the device being used is desktop, simply scroll the element into view
    if (device === "desktop") el.scrollIntoView({ behavior: behavior });
    // if the device is mobile, there's a bit more work (hence the reason this component was created)
    // the above "scrollIntoView" kind of works, but the offset of the headers on mobile result
    // in us losing the ability to scroll to the top of the page after calling scrollIntoView
    else {
        // we get the height of the mobile header AND the mobile title bar
        const mobileHeaderHeight = document.getElementById("mobile-header")
            .offsetHeight;
        const mobileTitleBarHeight = document.getElementById("mobile-title-bar")
            .offsetHeight;
        // we add the heights of those two elements for a total offset
        const offset = mobileHeaderHeight + mobileTitleBarHeight;
        // find the distance between the body and the top of the viewport
        const bodyRect = document.body.getBoundingClientRect().top;
        // find the distance between the element and the top of the viewport
        const elementRect = el.getBoundingClientRect().top;
        // get the element's "true" position
        const elementPosition = elementRect - bodyRect;
        // this is the position we want to scroll to.
        // take the element's position and subtract the offset we found earlier
        const offsetPosition = elementPosition - offset;

        // scroll that baby to the found offset position ;)
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    }
};
